import type { QueryParams } from 'common/actions/ideaQueries';
import type { Idea } from 'common/api/endpoints/idea';

// Partial as only some ideas have children and an array is only defined for ideas that have children.
export type IdeaHierarchy = Partial<Record<string, Idea[]>>;

export function calculateIdeaHierarchy(ideas: Idea[]): {
  hierarchy: IdeaHierarchy;
  maxDepth: number;
} {
  const hierarchy: IdeaHierarchy = {};

  for (const idea of ideas) {
    if (!idea.parentID) {
      continue;
    }
    if (!hierarchy[idea.parentID]) {
      hierarchy[idea.parentID] = [];
    }

    hierarchy[idea.parentID]?.push(idea);
  }

  // this is based on the assumption that the backend will not allow nesting more than 2 levels deep
  for (const parentID in hierarchy) {
    if (hierarchy[parentID]?.some((child) => hierarchy[child._id])) {
      return { hierarchy, maxDepth: 2 };
    }
  }

  return { hierarchy, maxDepth: 1 };
}

export function calculateQueryParams({
  groupBy,
  groupURLName,
  parentID,
  search,
  sort,
  viewURLName,
  filtering,
}: QueryParams): QueryParams {
  return {
    ...(groupBy ? { groupBy } : {}),
    ...(groupURLName ? { groupURLName } : {}),
    ...(parentID ? { parentID } : {}),
    ...(search ? { search } : {}),
    ...(!search && sort ? { sort } : {}),
    ...(viewURLName ? { viewURLName } : {}),
    ...(filtering ? { filtering } : {}),
  };
}
